import { getJORProducts } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { JoinOnRoadProduct } from '@/interfaces/entities/jor-product.interface';

export const JoinOnRoadService = {
  /**
   * Fetch join on road products
   * @returns
   */
  async getJORProducts(): Promise<JoinOnRoadProduct[] | null> {
    try {
      return await _http.HttpGet(`${getJORProducts}`);
    } catch (error) {
      console.error('Failed to load JOR products');
      return null;
    }
  },
} as const;
